import { App as AntApp, Button, Card, Input, Layout, Menu, Spin, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { getEmailTemplates, updateEmailTemplate } from '../../modules/driver/api';

const { Sider, Content } = Layout;
const { Text } = Typography;

const TEMPLATE_LABELS = {
  driver_approve: 'Driver Approval Email',
  driver_reject: 'Driver Rejection Email',
  driver_lock: 'Driver Lock Email',
};

const SIDEBAR_ITEMS = [
  {
    key: 'driver-emails',
    icon: <MailOutlined />,
    label: 'Driver Emails',
  },
];

const EmailTemplatesSection = ({ templates, savingKey, onUpdate, onSave }) => (
  <>
    <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
      Available variables: <code>{'{{driverName}}'}</code>, <code>{'{{contactUrl}}'}</code>,{' '}
      <code>{'{{driveWithPkupUrl}}'}</code>, <code>{'{{termsUrl}}'}</code>
    </Text>
    {templates.map((tpl) => (
      <Card key={tpl.key} title={TEMPLATE_LABELS[tpl.key] || tpl.name || tpl.key} style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8 }}>
          <Text strong>Subject</Text>
          <Input
            value={tpl.subject}
            onChange={(e) => onUpdate(tpl.key, { subject: e.target.value })}
            style={{ marginTop: 4 }}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <Text strong>Body</Text>
          <Input.TextArea
            value={tpl.body}
            onChange={(e) => onUpdate(tpl.key, { body: e.target.value })}
            rows={12}
            style={{ marginTop: 4 }}
          />
        </div>
        <Button type="primary" loading={savingKey === tpl.key} onClick={() => onSave(tpl)}>
          Save
        </Button>
      </Card>
    ))}
  </>
);

const SettingsPage = () => {
  const { message } = AntApp.useApp();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState(null);
  const [activeKey, setActiveKey] = useState('driver-emails');

  const load = () => {
    setLoading(true);
    getEmailTemplates().then(({ response }) => {
      setTemplates(Array.isArray(response) ? response : []);
      setLoading(false);
    });
  };

  useEffect(load, []);

  const update = (key, patch) => {
    setTemplates((prev) => prev.map((t) => (t.key === key ? { ...t, ...patch } : t)));
  };

  const save = (tpl) => {
    setSavingKey(tpl.key);
    updateEmailTemplate(tpl.key, { subject: tpl.subject, body: tpl.body }).then(({ error }) => {
      setSavingKey(null);
      if (error) {
        message.error(error.message || 'Failed to save template');
      } else {
        message.success('Template saved');
        load();
      }
    });
  };

  return (
    <Spin spinning={loading}>
      <div className="Content SettingsPage">
        <div className="ContentHeader">
          <div className="HeaderTitle">SETTINGS</div>
        </div>
        <Layout style={{ background: 'transparent' }}>
          <Sider width={220} theme="light" style={{ background: '#fff', borderRadius: 8, padding: 8 }}>
            <Menu
              mode="inline"
              selectedKeys={[activeKey]}
              onClick={({ key }) => setActiveKey(key)}
              items={SIDEBAR_ITEMS}
              style={{ borderInlineEnd: 'none' }}
            />
          </Sider>
          <Content style={{ paddingLeft: 24 }}>
            {activeKey === 'driver-emails' && (
              <EmailTemplatesSection templates={templates} savingKey={savingKey} onUpdate={update} onSave={save} />
            )}
          </Content>
        </Layout>
      </div>
    </Spin>
  );
};

export default SettingsPage;
